import { Component, OnInit } from '@angular/core';
import { AuthService } from '../_service/auth.service';
import { LocationService } from '../_service/location.service';
import { MatTreeFlattener, MatTreeFlatDataSource } from '@angular/material';
import { FlatTreeControl } from '@angular/cdk/tree';
import { takeUntil } from 'rxjs/operators';
import { SelectionModel } from '@angular/cdk/collections';
import { Subject, BehaviorSubject } from 'rxjs';

export class TodoItemNode {
  authorityUnitId: number;
  parentAuthorityUnitId: number;
  rootAuthorityUnitId: number;
  name: string;
  children?: TodoItemNode[];
  hasChild: boolean;
  isInLocation: boolean;
  isSuperAdmin: boolean;
  exists: boolean;
  userId: number;
}

/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  authorityUnitId: number;
  parentAuthorityUnitId: number;
  rootAuthorityUnitId: number;
  item: string;
  level: number;
  isInLocation: boolean;
  isSuperAdmin: boolean;
  expandable: boolean;
  userId: number;
}

@Component({
  selector: 'tree',
  templateUrl: './tree.component.html',
  styleUrls: ['./tree.component.css']
})
export class TreeComponent implements OnInit {

  constructor(
    private locationService: LocationService,
    public authService: AuthService,
  ) {
    this.treeFlattener = new MatTreeFlattener(
      this.transformer,
      this.getLevel,
      this.isExpandable,
      this.getChildren
    );
    this.treeControl = new FlatTreeControl<TodoItemFlatNode>(
      this.getLevel,
      this.isExpandable
    );
    this.dataSource = new MatTreeFlatDataSource(
      this.treeControl,
      this.treeFlattener
    );
    this.dataChange.subscribe(data => {
      this.dataSource.data = data;
    });
  }

  locationsFromResponse: any = [];
  location: TodoItemNode[] = [];
  grandChildrenAuthorityUnitId: any = [];
  childAuthorityUnitId: any = [];
  parentAuthorityUnitId: any = [];
  itemSelected: any;
  selectedItem: any = [];
  menuVisible: boolean = true;
  userId: any;
  sdsUserId: any;
  sdsUserIdNumber: number;
  selectedLocationId = [];
  siteAdminLocationId = [];
  emptyLocation: any;

  // loading: any = {};

  loading = false;

  model = {
    name: '',
    rootAuthorityUnitId: null,
    parentAuthorityUnitId: null
  };

  updateModel = {
    name: '',
    authorityUnitId: null,
    rootAuthorityUnitId: null,
    parentAuthorityUnitId: null
  };

  dataChange = new BehaviorSubject<TodoItemNode[]>([]);
  unsubscribe = new Subject<void>();

  ngOnInit() {
    this.userId = this.authService.decodedToken.nameid;
    this.sdsUserId = this.authService.decodedToken.userid;
    this.sdsUserIdNumber = +this.sdsUserId;
    if (this.authService.decodedToken.role === 'Site Admin') {
      this.getLocationsByUserId(this.userId);
    } else if (this.authService.decodedToken.role === 'Super Admin') {
      this.getTopLocations();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  checkAll() {
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if(!this.checklistSelection.isSelected(this.treeControl.dataNodes[i]))
        this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
    }
  }

  deselectAll() {
    for (let i = 0; i < this.treeControl.dataNodes.length; i++) {
      if(this.checklistSelection.isSelected(this.treeControl.dataNodes[i]))
        this.checklistSelection.toggle(this.treeControl.dataNodes[i]);
    }
  }
  
  getLoggedInUsersOutSideId() {
    if (this.authService.loggedIn()) {
      return this.authService.decodedToken.nameid;
    } else {
      return null;
    }
  }

  loggedIn() {
    return this.authService.loggedIn();
  }

  getTopLocations() {
    this.loading = true;
    return this.locationService.adminLocationHierarchy()
    .pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.locationsFromResponse = res;
      this.location = this.locationsFromResponse;
      this.dataSource.data = this.location;
      this.dataChange.value.push(this.locationsFromResponse);
      this.dataChange.next(this.location);
      this.loading = false;
    });
  }

  getLocationsByUserId(userId) {
    this.loading = true;
    return this.locationService.getLocationTreeByUserId(userId)
    .pipe(takeUntil(this.unsubscribe)).subscribe(res => {
      this.emptyLocation = res.headers.get('locationcount');
      console.log(this.emptyLocation);
      if (res.body !== null) {
        this.locationsFromResponse = res.body;
        this.location = this.locationsFromResponse;
        this.dataSource.data = this.location;
        this.dataChange.value.push(this.locationsFromResponse);
        this.dataChange.next(this.location);
        this.loading = false;
      }
      this.loading = false;
    });
  }

  get data(): TodoItemNode[] {
    return this.dataChange.value;
  }

  /** Map from flat node to nested node. This helps us finding the nested node to be modified */
  // tslint:disable-next-line: member-ordering
  flatNodeMap = new Map<TodoItemFlatNode, TodoItemNode>();

  /** Map from nested node to flattened node. This helps us to keep the same object for selection */
  // tslint:disable-next-line: member-ordering
  nestedNodeMap = new Map<TodoItemNode, TodoItemFlatNode>();

  /** A selected parent node to be inserted */
  // tslint:disable-next-line: member-ordering
  selectedParent: TodoItemFlatNode | null = null;

  /** The new item's name */
  // tslint:disable-next-line: member-ordering
  newItemName = '';

  // tslint:disable-next-line: member-ordering
  treeControl: FlatTreeControl<TodoItemFlatNode>;

  // tslint:disable-next-line: member-ordering
  treeFlattener: MatTreeFlattener<TodoItemNode, TodoItemFlatNode>;

  // tslint:disable-next-line: member-ordering
  dataSource: MatTreeFlatDataSource<TodoItemNode, TodoItemFlatNode>;

  /** The selection for checklist */
  checklistSelection = new SelectionModel<TodoItemFlatNode>(true);


  getLevel = (node: TodoItemFlatNode) => node.level;

  levelsExist = (node: TodoItemNode) => node.exists;

  isExpandable = (node: TodoItemFlatNode) => node.expandable;

  getChildren = (node: TodoItemNode): TodoItemNode[] => node.children;

  hasChild = (_: number, _nodeData: TodoItemFlatNode) => _nodeData.expandable;

  hasNoContent = (_: number, _nodeData: TodoItemFlatNode) =>
    _nodeData.item === '';

  /**
   * Transformer to convert nested node to flat node. Record the nodes in maps for later use.
   */
  transformer = (node: TodoItemNode, level: number) => {
    const existingNode = this.nestedNodeMap.get(node);
    const flatNode =
      existingNode && existingNode.item === node.name
        ? existingNode
        : new TodoItemFlatNode();
    flatNode.item = node.name;
    flatNode.level = level;
    flatNode.authorityUnitId = node.authorityUnitId;
    flatNode.parentAuthorityUnitId = node.parentAuthorityUnitId;
    flatNode.rootAuthorityUnitId = node.rootAuthorityUnitId;
    flatNode.isInLocation = node.isInLocation;
    flatNode.isSuperAdmin = node.isSuperAdmin;
    flatNode.userId = node.userId;

    if (node.hasChild) {
      flatNode.expandable = true;
    } else {
      flatNode.expandable = false;
    }

    this.flatNodeMap.set(flatNode, node);
    this.nestedNodeMap.set(node, flatNode);
    return flatNode;
  };

  descendantsAllSelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    this.clickevent();
    return descAllSelected && this.checklistSelection.isSelected(node);
  }

  descendantsPartiallySelected(node: TodoItemFlatNode): boolean {
    const descendants = this.treeControl.getDescendants(node);
    const result = descendants.some(child =>
      this.checklistSelection.isSelected(child)
    );
    return result && !this.descendantsAllSelected(node);
  }

  // test
testtest: any;

  deselectAllNodes(node: TodoItemFlatNode) {
    this.testtest = this.checklistSelection.deselect(node);
    return this.testtest;
  }

  todoItemSelectionToggle(node: TodoItemFlatNode): void {
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child => this.checklistSelection.isSelected(child));

    if (descAllSelected && this.checklistSelection.isSelected(node)) {
      this.checklistSelection.deselect(...descendants);
      this.checklistSelection.toggle(node);
    } else {
      this.checklistSelection.select(...descendants);
      if (!this.checklistSelection.isSelected(node)) {
        this.checklistSelection.toggle(node);
      }
    }
    if (!this.checklistSelection.isSelected(node)) {
      this.deselectAllParents(node);
    }

    this.parentAuthorityUnitId = node.authorityUnitId;
    this.childAuthorityUnitId = descendants;
  }

  deselectAllParents(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      if (this.checklistSelection.isSelected(node)) {
        this.checklistSelection.toggle(node);
      }
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  todoLeafItemSelectionToggle(node: TodoItemFlatNode): void {
    this.checklistSelection.toggle(node);
    if (!this.checklistSelection.isSelected(node)) {
      this.deselectAllParents(node);
    }
  }

  checkAllParentsSelection(node: TodoItemFlatNode): void {
    let parent: TodoItemFlatNode | null = this.getParentNode(node);
    while (parent) {
      this.checkRootNodeSelection(parent);
      parent = this.getParentNode(parent);
    }
  }

  checkRootNodeSelection(node: TodoItemFlatNode): void {
    const nodeSelected = this.checklistSelection.isSelected(node);
    const descendants = this.treeControl.getDescendants(node);
    const descAllSelected = descendants.every(child =>
      this.checklistSelection.isSelected(child)
    );
    if (nodeSelected && !descAllSelected) {
      this.checklistSelection.deselect(node);
    } else if (!nodeSelected && descAllSelected) {
      this.checklistSelection.select(node);
    }
  }

  getParentNode(node: TodoItemFlatNode): TodoItemFlatNode | null {
    const currentLevel = this.getLevel(node);
    if (currentLevel < 1) {
      return null;
    }

    const startIndex = this.treeControl.dataNodes.indexOf(node) - 1;

    for (let i = startIndex; i >= 0; i--) {
      const currentNode = this.treeControl.dataNodes[i];

      if (this.getLevel(currentNode) < currentLevel) {
        return currentNode;
      }
    }
    return null;
  }
  clickevent = () => {};
}